import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Store } from '@ngrx/store';

import { GopherBuddyAppState } from '../../../+state/app.state';
import { MaterialModule } from '../../material/material.module.ts/material/material.module';

@Component({
  selector: 'app-gb-deviceinfo',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './device-info.component.html',
  styleUrls: ['./device-info.component.scss'],
})
export class DeviceInfoComponent {
  constructor(public appState: Store<GopherBuddyAppState>) {}
}
